<script setup lang="ts">
type Props = { header?: string }
const props = defineProps<Props>()

const pageData = { imageLogo: await import('@/assets/images/logo-short-internet-museum.png') }
</script>

<template>
  <div class="c-topSectionHeader">
    <div
      class="c-topSectionHeader_image"
    >
      <v-img
        v-bind:src="pageData.imageLogo.default"
      />
    </div>
    <div
      class="c-topSectionHeader_title"
    >
      {{ header }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-topSectionHeader {
  display: flex;
  color: var(--color_text_base);
  font-family: var(--g_font_family_SawarabiGothic);

  @include responsive.mq_down(sp) {
    align-items: center;
    padding: 0 var(--g_guide_margin_sp);
  }

  &_image {
    width: 26px;

    @include responsive.mq_down(sp) {
      width: 20px;
    }
  }

  &_title {
    flex: 1;
    margin-left: 10px;
    font-size: 20px;
    font-weight: 400;

    @include responsive.mq_down(sp) {
      font-size: 18px;
    }
  }
}
</style>
